export default "__VITE_ASSET__CWFGQIHw__"